// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-bell { 
  position: relative; 
  display: inline-block; 
  margin-right: 12px; 
}

.bell-btn { 
  background: transparent; 
  border: none; 
  cursor: pointer; 
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 8px;
  min-width: 36px;
  min-height: 36px;
  border-radius: 50%;
  transition: all 0.2s;
}

.bell-btn:hover {
  background: var(--bg-tertiary);
}

.bell-btn svg {
  width: 20px;
  height: 20px;
  stroke: var(--text-primary);
  transition: all 0.2s;
}

.bell-btn svg.has-unread {
  stroke: var(--accent-primary);
}

.badge { 
  background: var(--accent-primary); 
  color: white; 
  border-radius: 999px; 
  padding: 2px 5px; 
  font-size: 11px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
  position: absolute;
  top: 1px;
  right: 1px;
  line-height: 1;
  box-shadow: 0 0 0 2px var(--bg-secondary);
  pointer-events: none;
}

.badge-loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  min-height: 18px;
  padding: 0;
}

.badge-spinner {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.45);
  border-top-color: white;
  animation: notification-badge-spin 0.7s linear infinite;
}

@keyframes notification-badge-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .notification-bell {
    margin-right: 8px;
  }

  .bell-btn {
    padding: 7px;
    min-width: 34px;
    min-height: 34px;
  }
}

.notif-dropdown { 
  position: absolute; 
  right: 0; 
  top: 40px; 
  width: 320px; 
  background: var(--bg-secondary);
  border: 1px solid var(--border-color); 
  border-radius: 12px;
  box-shadow: 0 4px 12px var(--shadow-color); 
  z-index: 50;
  overflow: hidden;
}

.notif-header { 
  padding: 12px 16px; 
  font-weight: 600; 
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notif-header-link {
  font-size: 13px;
  font-weight: 500;
  color: var(--accent-primary);
  text-decoration: none;
  transition: all 0.2s;
}

.notif-header-link:hover {
  text-decoration: underline;
}

.notif-list { 
  list-style: none; 
  margin: 0; 
  padding: 8px; 
  max-height: 360px; 
  overflow: auto;
}

.notif-item { 
  padding: 8px; 
  border-bottom: 1px solid var(--border-color);
}

.notif-item.unread { 
  background: var(--hover-bg);
}

.notif-time { 
  font-size: 12px; 
  color: var(--text-secondary); 
}

.notif-payload { 
  font-size: 13px; 
  margin-top: 4px;
  color: var(--text-primary);
}

.notif-empty { 
  padding: 16px; 
  color: var(--text-secondary);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationBell/NotificationBell.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6CAA6C;EAC7C,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;AACpB","sourcesContent":[".notification-bell { \r\n  position: relative; \r\n  display: inline-block; \r\n  margin-right: 12px; \r\n}\r\n\r\n.bell-btn { \r\n  background: transparent; \r\n  border: none; \r\n  cursor: pointer; \r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0;\r\n  padding: 8px;\r\n  min-width: 36px;\r\n  min-height: 36px;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.bell-btn:hover {\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.bell-btn svg {\r\n  width: 20px;\r\n  height: 20px;\r\n  stroke: var(--text-primary);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.bell-btn svg.has-unread {\r\n  stroke: var(--accent-primary);\r\n}\r\n\r\n.badge { \r\n  background: var(--accent-primary); \r\n  color: white; \r\n  border-radius: 999px; \r\n  padding: 2px 5px; \r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  min-width: 18px;\r\n  text-align: center;\r\n  position: absolute;\r\n  top: 1px;\r\n  right: 1px;\r\n  line-height: 1;\r\n  box-shadow: 0 0 0 2px var(--bg-secondary);\r\n  pointer-events: none;\r\n}\r\n\r\n.badge-loading {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 18px;\r\n  min-height: 18px;\r\n  padding: 0;\r\n}\r\n\r\n.badge-spinner {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  border: 1.5px solid rgba(255, 255, 255, 0.45);\r\n  border-top-color: white;\r\n  animation: notification-badge-spin 0.7s linear infinite;\r\n}\r\n\r\n@keyframes notification-badge-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .notification-bell {\r\n    margin-right: 8px;\r\n  }\r\n\r\n  .bell-btn {\r\n    padding: 7px;\r\n    min-width: 34px;\r\n    min-height: 34px;\r\n  }\r\n}\r\n\r\n.notif-dropdown { \r\n  position: absolute; \r\n  right: 0; \r\n  top: 40px; \r\n  width: 320px; \r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color); \r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px var(--shadow-color); \r\n  z-index: 50;\r\n  overflow: hidden;\r\n}\r\n\r\n.notif-header { \r\n  padding: 12px 16px; \r\n  font-weight: 600; \r\n  border-bottom: 1px solid var(--border-color);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.notif-header-link {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.notif-header-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.notif-list { \r\n  list-style: none; \r\n  margin: 0; \r\n  padding: 8px; \r\n  max-height: 360px; \r\n  overflow: auto;\r\n}\r\n\r\n.notif-item { \r\n  padding: 8px; \r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.notif-item.unread { \r\n  background: var(--hover-bg);\r\n}\r\n\r\n.notif-time { \r\n  font-size: 12px; \r\n  color: var(--text-secondary); \r\n}\r\n\r\n.notif-payload { \r\n  font-size: 13px; \r\n  margin-top: 4px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.notif-empty { \r\n  padding: 16px; \r\n  color: var(--text-secondary);\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
